import type { FaireProductEntity } from "../../entity_types/product";

export const p_jwba8zf33g: FaireProductEntity = {
  token: "p_jwba8zf33g",
  type: "product",
  name: "TITANIUM  STEEL NON-TARNISH KNOTTED NECKLACE | 40NK337",
  brandToken: "b_9j5az29aau",
  brandName: "JOSSLYN by wall to wall",
  imageUrl:
    "https://cdn.faire.com/fastly/ea664bf1e86c9cc02b1c8b0a2a9740dd19afaed8671399a5159678e628912929.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ca3d41e8963a3fb5f236ccb63e0482b706dff871119cbacc2bcef5fcbf5e08dc.jpeg",
    "https://cdn.faire.com/fastly/f706236aa8e8b10223a54e521274ba6400ac3431cad99940c5c74ed2df6a5557.jpeg",
    "https://cdn.faire.com/fastly/4e77dfe8fc14b34469d108c558dd2f64bbc1623add6f35f7561764f6a100041d.jpeg",
    "https://cdn.faire.com/fastly/332df22a1246000d6a302c7d11f2a652ba224e139cd18cb1eab69d7f8b16ef35.jpeg",
    "https://cdn.faire.com/fastly/a5c1c9962d2e24806fefa4536a302890de3dee1e695643964c4171b40fba6547.jpeg",
  ],
  priceDollars: 4.85,
  description:
    'Titanium Steel Non-Tarnish Knotted Necklace. Expertly crafted from high-quality titanium steel, this necklace is designed to resist tarnishing, ensuring it maintains its beautiful shine over time. The unique knotted design adds a distinctive touch of sophistication, making it an ideal accessory for both casual and formal occasions. \n\nProduct Details:\nlength:  16"\next: 2" ext\nclasp: Lobster Claw\nMetal finish: Titanium Steel Gold\nproduct: Lead & Nickel Compliant\nanti-tarnish:  Tarnish Free, Non-Tarnish\n\nHere are some of the key features of titanium bracelets:\nLightweight\nTemperature Resistance\nCorrosion Resistance\nResistant to rust\nReal Gold Dipped Necklace\nHypoallergenic Necklace\nTarnish-Free Necklace\nNon-Tarnish Necklace\nWater Resistant Necklace\nSweatproof Necklace\nFade Resistant Necklace',
  tags: [],
  msrpDollars: 9.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:43.576Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
